import axios from "@/utils/request";
// 法律法规 - 列表
export const lawList=(data:any)=>{
    return axios({
        path:"/WSZF/json/BPCWebAction!list",
        data
    })
}

// 法律法规 - 详情
export const lawDetail=(data:any)=>{
    return axios({
        path:"/WSZF/json/BPCWebAction!findBeanById",
        data
    })
}

export const saveTrainLog = (data:any)=>{
    return axios({
        path:"/onlineMedical/medicalComp/system/addTrainLog",
        method:"POST",
        data
    })
}
